export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Diagonal%20sweep%20of%20fashion%20items%20including%20a%20pair%20of%20sneakers%20leather%20belt%20sunglasses%20and%20a%20folded%20cashmere%20sweater%20arranged%20dynamically%20across%20warm%20cream%20surface%2C%20strong%20diagonal%20composition%20from%20bottom%20left%20to%20top%20right%2C%20soft%20morning%20light%20creating%20long%20gentle%20shadows%2C%20minimal%20editorial%20style%2C%20warm%20beige%20and%20caramel%20tones%2C%20movement%20and%20flow%20concept%2C%20high%20end%20product%20photography%2C%20dynamic%20yet%20elegant&width=1800&height=800&seq=cta-bg-diagonal-v2&orientation=landscape"
        alt="Superbuy Spreadsheet product collection background"
        title="Superbuy Spreadsheet full product collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      {/* Content */}
      <div className="relative h-full w-full px-6 md:px-10 lg:px-16 flex items-center">
        <div className="max-w-5xl w-full">
          {/* Top-left: Main title */}
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-none tracking-tight">
            get full access
          </h2>

          {/* Bottom area: CTA button + description */}
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mt-10 md:mt-16 gap-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-background-50 text-foreground-950 font-label font-semibold text-sm rounded-full hover:bg-background-100 transition-colors w-fit cursor-pointer whitespace-nowrap"
            >
              Shop Kaspreadsheet
              <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-background-50 text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
              </span>
            </a>

            <p className="text-background-50/80 text-sm md:text-base font-label leading-relaxed max-w-xs">
              Explore the complete product collection<br />with curated categories and comparison tools.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}